/*
 * Created by jmeo at 2021-05-13
 * FileName: store.ts
 */

import { isEmpty } from '@util/index'

const storage = localStorage

export function getItem(key: string, defaultVal?: any) {
  return storage.getItem(key) || defaultVal
}

export function getItemObj<T>(key: string): any {
  const item = getItem(key)
  if (item && !isEmpty(item)) {
    return JSON.parse(item)
  }
  return {} as T
}

export function setItem(key: string, val: string) {
  storage.setItem(key, val)
}

export function setItemObj(key: string, val: any) {
  setItem(key, JSON.stringify(val))
}

export function removeItem(key: string) {
  storage.removeItem(key)
}

export default {
  getItem,
  setItem,
  removeItem,
}
